import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles/index"

import { NavTopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { BILLS_ROUTES } from "@routes/bills"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { BILLS_LIST_CONTROLS_VIEW } from "@constants/storage"

import BillTableView from "./views/BillTableView/BillTableView"

export default function BillList() {
    const [createRoute] = useSlugExtractor([BILLS_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="bill-list">
            <ViewTypesProvider viewTypes={["table"]} viewTypeKey={BILLS_LIST_CONTROLS_VIEW} defaultViewType="table">
                {() => (
                    <>
                        <NavTopBar.Root>
                            <NavTopBar.Header>
                                <NavTopBar.NavTopBarHeaderStart>
                                    <NavTopBar.PageTitle
                                        label={objectMap.bill.labelPlural}
                                        icon={objectMap.bill.iconActive}
                                    />
                                </NavTopBar.NavTopBarHeaderStart>
                                <NavTopBar.NavTopBarHeaderEnd>
                                    <NavTopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            bills_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                bills_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <NavTopBar.SearchButton scope="Bills" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <AccessCheck
                                        permissions={{
                                            bills_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <NavTopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </NavTopBar.NavTopBarHeaderEnd>
                            </NavTopBar.Header>
                        </NavTopBar.Root>
                        <BillTableView />
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
